<template>
<div>
  <querytitle>
    <template slot="queryleft">
      <div style="padding-right: 20px">
        <span style="color: red; font-size: 15px; font-weight: bold">{{SFT.TNAME}}</span>
      </div>
      <div style="text-align: left">
        <span style="color: #000"></span>
        <span>{{ SFT.TDESC }}</span>
      </div>
    </template>
    <template slot="queryright">
      <el-tag type="success" size="mini">已下达</el-tag>
      <el-tag type="danger" size="mini">未下达</el-tag>
    </template>
  </querytitle>
  <div :style="'height:' + hh + 'px;'" class="send">
    <input type="file" ref="xlsxbutton" accept=".pdf" @change="uploadfiles" style="display: none" />
    <div v-for="(item,index) in itemlist" :key="item.SSID" :class="item.ZWID ? 'senditemact':'senditem'">
      <div class="title">
        <div>
          <div>班级：{{ item.SCNAME }}</div>
          <div>姓名：{{ item.SSNAME }}</div>
        </div>
        <div><i class="el-icon-user-solid" style="font-size:40px;"></i></div>
      </div>
      <div class="content">
        <div>选题：{{ item.SSTITLE }}</div>
      </div>
      <div class="content">
        <div>任务书：{{item.FILENAME}}</div>
        <div v-if="item.ZWID">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="del(item,index)" circle></el-button>
        </div>
        <div v-else>
          <filedialogbutton :icon="'el-icon-bottom'" :par="{objname:'zj_works',zjclass:'任务书',ZJS:[],SSID:item.SSID}" :TNAME="''" :okupload="uploaded"></filedialogbutton>
          <!-- <el-button type="primary" size="mini" icon="el-icon-bottom" @click="changefile(item,index)" circle></el-button> -->
        </div>
      </div>
    </div>
  </div>
  <sftsumit :SFT="SFT" :chkdata="chkdata"></sftsumit>
</div>
</template>

<script>
import querytitle from "@/components/querytitle";
import sftsumit from "@/components/sftsumit";
import filedialogbutton from '@/components/filedialogbutton'
export default {
  components: {
    querytitle,
    sftsumit,
    filedialogbutton
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.params.SFT != from.params.SFT) {
        //pid不为空才请求数据
        this.init();
      }
    },
  },
  data() {
    return {
      hh: 500,
      itemlist: [],
      SFT: null,
      currentfile: null,
      currentfiledesc: '',
      itemedit: {},
      itemindex: 0,
      // pars:{objname:'zj_works',zjclass:'任务书',ZJS:[],SSID:''}
    };
  },
  created() {
    this.init();
  },
  methods: {
    uploaded(res){
      const that = this
      that.$refs.xlsxbutton.value = "";
      that.itemedit.ZWID = res.data.fileinfo.ZWID
      that.itemedit.FILENAME = res.data.fileinfo.FILENAME
      that.itemedit.FILEPATH = res.data.fileinfo.FILEPATH
      that.$set(that.itemlist, that.itemindex, that.itemedit);
      that.getlist();
    },
    init() {
      this.SFT = this.GetSFT();
      this.hh = document.documentElement.clientHeight - 240;
      this.getlist();
    },
    getlist() {
      const that = this;
      that.PostData(
        "Common/GetOtherMethod", {
          methodname: "GetStudnetWorks",
          pars: {
            "STID": that.CU.cu.uid
          }
        },
        function (res) {
          that.itemlist = res.data.data;
        },
        function (err) {}
      );
    },
    del(item, index) {
      this.itemedit = Object.assign({}, item);
      console.log(item)
      this.itemindex = index
      const that = this;
      that
        .$confirm("确定要删除当前学生的任务书吗？", "询问", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          var pars = {
            objname: "zj_works",
            model: {
              ZWID: item.ZWID,
              FILENAME: item.FILENAME,
              FILEPATH: item.FILEPATH
            }
          };
          that.PostData(
            "Common/DEL",
            pars,
            function (res) {
              console.log(res)
              if (res.data.error_code != 0) {
                that.$alert(res.data.message, {
                  title: "错误"
                });
                return;
              }
              that.itemedit.ZWID = ""
              that.itemedit.FILENAME = ""
              that.$set(that.itemlist, that.itemindex, that.itemedit);
            },
            function (err) {
              console.log(err)
            }
          );
        })
        .catch(() => {});
    },

    changefile: function (item, index) {
      this.itemedit = Object.assign({}, item);
      this.itemindex = index
      this.$refs.xlsxbutton.click();
    },
    getext: function (filename) {
      var index1 = filename.lastIndexOf(".");
      var index2 = filename.length;
      var postf = filename.substring(index1 + 1, index2).toLowerCase(); //后缀名
      //alert(postf);
      return postf;
    },
    uploadfiles(e) {
      this.currentfile = null;
      const that = this;
      var fts = ["pdf"];
      var files = e.target.files || e.dataTransfer.files;
      if (files.length > 1) {
        that.$alert("一次只能上传1个文件。", {
          title: "错误"
        });
        this.$refs.xlsxbutton.value = "";
        return;
      }
      if (files[0].size > 5120576) {
        that.$alert("文件不能大于5MB!", {
          title: "错误"
        });
        this.$refs.xlsxbutton.value = "";
        return;
      }
      var ext = that.getext(files[0].name);
      if (fts.indexOf(ext) < 0) {
        that.$alert("不支持当前的文件格式" + ext + "！", {
          title: "错误"
        });
        this.$refs.xlsxbutton.value = "";
        return;
      }
      this.currentfile = files[0];
      this.currentfiledesc = files[0].name;
      this.$refs.xlsxbutton.value = "";
      this.$prompt("任务书文件名称", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /'*/,
          inputPlaceholder: "请输入文件名称",
          inputValue: that.currentfiledesc,
          inputErrorMessage: "请输入文件名称",
        })
        .then(({
          value
        }) => {
          let pars = {
            objname: "zj_works",
            SID: that.itemedit.SID,
            SSID: that.itemedit.SSID,
            ZJCLASS: '任务书',
            FILENAME: value,
          };
          const loading = that.$loading({
                    lock: true,
                    text: '正在上传，请稍候...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
          that.PostFile(
            "uploadFile",
            pars,
            that.currentfile,
            function (res) {
              that.$refs.xlsxbutton.value = "";
              that.itemedit.ZWID = res.data.fileinfo.ZWID
              that.itemedit.FILENAME = res.data.fileinfo.FILENAME
              that.itemedit.FILEPATH = res.data.fileinfo.FILEPATH
              that.$set(that.itemlist, that.itemindex, that.itemedit);
              that.getlist();
              loading.close()
            },
            function (err) {
              loading.close()
              that.$alert(err, {
                title: "错误"
              });

            },function(press){
              loading.text ='正在上传，请稍候...'+ press+"%";
            }
          );
        }).catch((err) => {

        });
    },
    chkdata(callback, errback) {
      let zwcount = 0;
      this.itemlist.forEach(item => {
        if (!item.ZWID)
          zwcount++
      })
      if (zwcount > 0) {
        errback("还有未下达任务书的学生！");
      } else {
        callback("");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.send {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  overflow: auto;
  padding: 1px;
  border: 1px solid #ebeef5;
  flex-wrap: wrap;
}

.senditemact {
  margin: 5px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 150px;
  background-color: #e6f7e8;
  border-color: #ccefd0;
  color: #00b014;
}

.senditem {
  padding: 5px;
  margin: 5px;
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 150px;
  background-color: #fee7e7;
  border-color: #fdd0d0;
  color: #f51212;
}

.title {
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
  font-weight: bold;
  font-size: 14px;

  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  text-align: left;
  padding: 5px;
}

.footer {
  font-size: 13px;
  text-align: left;
  padding: 5px;
}
</style>
